/**
 * Phone browsers have no wallet extension. These links open the current page inside a wallet app's own browser,
 * where the wallet is injected and connects like a desktop extension. Every other wallet goes through WalletConnect.
 */
export interface WalletAppLink {
  name: string;
  href: string;
}

export function walletAppLinks(pageUrl: string): WalletAppLink[] {
  const url = new URL(pageUrl);
  const okx = `okx://wallet/dapp/url?dappUrl=${encodeURIComponent(url.href)}`;
  return [
    { name: 'MetaMask', href: `https://metamask.app.link/dapp/${url.host}${url.pathname}${url.search}` },
    // coin_id 20000714 is BNB Smart Chain, so Trust opens the page on the right network
    { name: 'Trust Wallet', href: `https://link.trustwallet.com/open_url?coin_id=20000714&url=${encodeURIComponent(url.href)}` },
    { name: 'OKX Wallet', href: `https://www.okx.com/download?deeplink=${encodeURIComponent(okx)}` },
  ];
}

export function isMobileBrowser(userAgent: string): boolean {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
}
